// store/index.js
import Vue from "vue";
import Vuex from "vuex";
import masterStore from "./modules/MasterStore";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    masterStore
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js